$(document).ready(function () {
	$(document).on('click', '.btn-product-to-basket', function () {
		var variant = 0;

		var priceRelated = $(this).data('price-related');
		if (priceRelated) {
			variant = $('#' + priceRelated).find('.variant-box-item.active').data('id');
		}

		var params = {
			_token: App.csrf,
			id: $(this).data('id'),
			variant: variant
		};

		$.post('/cart/add_product', params, function (data) {
			if (!data.error) {
				Cart.updateCnt(data.cnt);
				Cart.showModalAdded(data.product_title);
			}
		});
	});

	$(document).on('change', '.table-cart .qty', function () {
		$tr = $(this).closest('tr');
		var id = $tr.data('id');
		var price_id = $tr.data('price-id');
		var cnt = $(this).val();

		var params = Cart.formParams({
			id: id,
			price_id: price_id,
			data: {cnt: cnt}
		});

		$.post('/cart/change_product', params, function (data) {
			Cart.updateTotals(data);
			Cart.updateCnt(data.cnt);

			$('.table-cart tr[data-id="' + id + '"][data-price-id="' + price_id + '"]')
				.find('.pro-subtotal span')
				.text(data.product_total_formatted)
			;
		});
	});
	$(document).on('click', '.table-cart .btn-del', function () {
		$tr = $(this).closest('tr');
		var id = $tr.data('id');
		var price_id = $tr.data('price-id');

		var params = Cart.formParams({
			id: id,
			price_id: price_id,
		});

		$.post('/cart/del_product', params, function (data) {
			$tr.remove();

			Cart.updateTotals(data);
			Cart.updateCnt(data.cnt);

			if (!$('.table-cart tbody tr').length)
				location.reload();
		});

		return false;
	});

	$(document).on('click', '.minicart-remove', function () {
		$item = $(this).closest('.minicart-item');
		var id = $item.data('id');
		var price_id = $item.data('price-id');

		var params = {
			id: id,
			price_id: price_id,
			_token: App.csrf,
			get_view: 'minicart'
		};

		$.post('/cart/del_product', params, function (data) {
			$item.slideUp();

			if ($('.table-cart').length) {
				$('[data-id=' + id + ']').remove();

				if (!$('.table-cart tbody tr').length)
					location.reload();
			}

			Cart.updateTotalsMinicart(data);
			Cart.updateCnt(data.cnt);
		});

		return false;
	});

	$(document).on('change', '#form-make-order select[name=delivery]', function () {
		var val = parseInt($(this).val()),
			$form = $('.form-make-order');

		if (val === 1) {
			$form.find('.fg-store-id').show();
			$form.find('.fg-user-address').hide();
		} else if (val === 2) {
			$form.find('.fg-store-id').hide();
			$form.find('.fg-user-address').show();
		}

		Cart.updateTotals();
	});

	$('.variant-box-item').click(function () {
		$(this).closest('.variant-box').find('.variant-box-item').removeClass('active');
		$(this).addClass('active');

		let price_old = $(this).data('price-old');
		let price_current = $(this).data('price-current');

		if (price_old) {
			$('.price-box-old > span').text(price_old).css('opacity', 1).css('visibility', 'visible');
		} else {
			$('.price-box-old > span').text(price_old).css('opacity', 0).css('visibility', 'hidden');
		}

		$('.price-box-current > span').text(price_current);

		return false;
	});

	$('#promocode-activate').click(function () {
		var params = Cart.formParams(),
			$alerts = $('.alerts'),
			$danger = $alerts.find('.alert-danger'),
			$success = $alerts.find('.alert-success');

		$danger.fadeOut();
		$success.fadeOut();

		$.get('/cart/activate_promocode', params, function (data) {
			if (data.error) {
				if (data.error === 'not_found') {
					$danger.text($danger.data('not-found')).fadeIn();
				} else if (data.error === 'expired') {
					$danger.text($danger.data('expired')).fadeIn();
				}
			} else {
				Cart.updateTotals(data);
				$success.text($success.data('success')).fadeIn();
			}

			return false;
		});

		return false;
	});
});